import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgDialog, IgTypography } from "@intelligems/ig-theme";
import { getDialog, setDialog } from "@src/store/slices/global";
import { openNewTab } from "@src/utils/openNewTab";

export const ModifyStripeSubscriptionDialog = () => {
  const dispatch = useDispatch();
  const dialog = useSelector(getDialog("modifyStripeSubscription"));

  const handleClose = () => {
    dispatch(
      setDialog({
        dialog: "modifyStripeSubscription",
        open: false,
        props: undefined,
      })
    );
  };

  if (!dialog.isOpen) {
    return null;
  }

  return (
    <IgDialog
      showCloseIcon={true}
      title={"Heads up!"}
      content={
        <IgTypography>
          Changing your plan can affect your billing, and we want to make sure
          everything goes smoothly—no surprises. Reach out to our team, and
          we’ll help you get it right!
        </IgTypography>
      }
      handleClose={handleClose}
      dialogHeight={null}
      maxWidth={"lg"}
      dialogContentWidth={"400px"}
      showDialog={dialog.isOpen}
      yesButtonText={"Contact Us"}
      handleYesClick={() => {
        openNewTab("portal.usepylon.com/intelligems/forms/plan-change-request");
        handleClose();
      }}
      noButtonText={"Close"}
      handleNoClick={handleClose}
    />
  );
};
